<template>
  <div class="landing-page">
    <div class="landing-page__container">
      <div class="landing-page__box">
        <div class="landing-page__column">
          <img src="@/assets/vizcloud_icon-new-01.png" alt="VizNow" />
          <h1>{{ t("welcome") }}</h1>
          <p>{{ t("easyAccess") }}</p>
        </div>

        <div class="landing-page__column landing-page__column--light">
          <div @click="openDownloadLink" class="landing-page__button">
            <v-icon :size="40" color="primary">action_run</v-icon>
            <span>{{ t("downloadLaunchPad") }}</span>
          </div>

          <div class="landing-page__row">
            <p v-html="t('firstTimeUsers')" class="landing-page__label" />

            <div class="landing-page__divider landing-page__divider--vertical"></div>

            <p v-html="t('ifAlreadyInstalled')" class="landing-page__label" />
          </div>
        </div>
      </div>

      <div class="landing-page__divider landing-page__divider--horizontal"></div>

      <div class="landing-page__column landing-page__column--simple">
        <span class="landing-page__row landing-page__row--gap-false">
          <v-icon left>status_question</v-icon>
          {{ t("guide") }}
        </span>

        <a :href="launchPadDocumentation" target="_blank">{{ t("documentation") }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount } from "@vue/composition-api"
import { appLauncherDownloadLink, launchPadDocumentation } from "@/config/download-app-launcher-link"
import { DefaultRoute } from "@/router/lib/default-routes"
import { useWebview } from "@/composable/useWebview"
import { createTranslationModule } from "@/plugins/i18n"
import { navigate } from "@/router"
import "./landing-page.scss"

export default defineComponent({
  name: "LandingPage",
  setup() {
    const { appLauncherDetected } = useWebview()
    const t = createTranslationModule("LandingPage")

    const openDownloadLink = () => {
      window.open(appLauncherDownloadLink, "_blank")
    }

    const _validateRouteRequirement = () => {
      if (appLauncherDetected.value) {
        navigate({ name: DefaultRoute.SAAS_APP_LAUNCHER })
      }
    }

    onBeforeMount(() => {
      _validateRouteRequirement()
    })

    return {
      t,
      launchPadDocumentation,
      openDownloadLink
    }
  }
})
</script>
